import React, { Component } from "react"

import Header from "./header"
import Footer from "./footer"
import Info from "./info"
import ListStudents from "./list-students"

class Data extends Component {
  componentDidMount() {
    //window.print()
  }

  render() {
    const header = this.props.data.get("header")
    const students = this.props.data.get("students")
    const session = this.props.session

    return (
      <div className="page container">
        <Header data={header.get("sem")} session={session} />
        <div className="content">
          <Info data={header} />
          <ListStudents students={students} />
        </div>
        <Footer instructor={header.getIn(["employee", "full_name1"])} dean="" />
      </div>
    )
  }
}

export default Data



// WEBPACK FOOTER //
// ./src/containers/Print/GradesSubmitted/data.js